(async () => {
    const { Core } = await importModule('Core');
    const { Swiper } = await importModule('Swiper');
 
    const ATTR_INITIAL_POSITION = 'initial-image-position'
 
    customElements.define('product-gallery', class extends Core {
        elements = {
            swiper: '[data-swiper]',
            pagination: '[data-pagination]'
        }
 
        subscriptions = {
            'variant:change': '_onVariantChange'
        }
 
        render() {
            this._initSwiper();
            this.subscribe('variant:change');
        }
 
        _initSwiper() {
            this.swiper = new Swiper(this.$swiper, {
                autoHeight: true,
                pagination: {
                    el: this.$pagination,
                    type: 'bullets'
                },
                breakpoints: {
                    992: {
                        allowTouchMove: false
                    }
                },
                        on: {
            slideChange: function () {
              if (typeof productOptions != "undefined") {
                if (productOptions.length > 0) {
                 
                  var current_slide = this.slides[this.activeIndex];
                  if (current_slide) {  
                  var current_slide_img = current_slide.querySelector("img");
 
                  if (current_slide_img) {
                    var arrImage = current_slide_img
                      .getAttribute("src")
                      .split("?")[0]
                      .split(".");
                    var strExtention = arrImage.pop();
                    var strRemaining = arrImage
                      .pop();
                      //.replace(/_[a-zA-Z0-9@]+$/, "");
                    var strNewImage =
                      arrImage.join(".") +
                      "." +
                      strRemaining +
                      "." +
                      strExtention;
                    if (typeof variantImages !== "undefined") {
                       
                      if (typeof variantImages[strNewImage] !== "undefined") {
                        productOptions.forEach(function (value, j) {
                       
                          var optionValue =
                            variantImages[strNewImage]["option-" + j];
                          if (optionValue !== null) {
                            var options_blocks = document.querySelectorAll(
                              "product-options-dropdown select option"
                            );
                            // debugger;
                            for (var k = 0; k < options_blocks.length; k++) {
        
                              if (optionValue === options_blocks[k].value) {
                                 options_blocks[k].closest("select").value = optionValue;
                              //  options_blocks[k].value = optionValue;
                              //  debugger;
                                options_blocks[k].closest("select").dispatchEvent(
                                  new Event("change", { bubbles: true })
                                );
                              }
                            }
                          }
                        });
                      }
                    }
                  }
                }
                }
              }
            }
          }
            });
            if (this.initialPosition) {
                this.swiper.slideTo(+this.initialPosition - 1)
            }
        }
 
        _onVariantChange({ variantImagePosition}) {
            if(variantImagePosition) {
                this.swiper.slideTo(variantImagePosition - 1);
            }
        }
 
        get slider() {
            return this.swiper;
        }
 
        get initialPosition() {
            return this.getAttribute(ATTR_INITIAL_POSITION)
        }
    })
})();